const isValidPassword = (password: string) => {
  const regex =
    /^(?=[^A-Z\s]*[A-Z])(?=[^a-z\s]*[a-z])(?=[^\d\s]*\d)(?=\w*[\W_])\S{6,15}$/;
  return regex.test(password);
};
export default isValidPassword;
